// removed by extract-text-webpack-plugin
module.exports = {"descBox":"template_descBox_t5K-j","title":"template_title_2mD2W","chartsLayout":"template_chartsLayout_2WDaz","chartBox":"template_chartBox_2jmC3","indexWrap":"template_indexWrap_Z9qwK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/template.scss
// module id = 1545
// module chunks = 0